import { VerificationAdditionalCheckStatusEnum } from '@/enums';
import { GenderEnum, VerificationTypesEnum } from '@/lib/enum';
import { ICertificationCount } from '@/lib/interface';
import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { apiClient } from '@/components/api';
import routes from '@/lib/routes';

type TParams = {
  additionalCheckStatus?: VerificationAdditionalCheckStatusEnum;
  type: VerificationTypesEnum;
  gender?: GenderEnum;
};
type TResponseData = ICertificationCount;

export const useRequestGetVerificationsCount = (params: TParams, run = true) => {

  const { isFetching, data, error, refetch } = useQuery({
    queryKey: [routes.api.verifications.count, params, run],
    queryFn: ({ queryKey: [_url, _params, _run] }) =>
      !_run
        ? Promise.resolve(null)
        : apiClient
          .get<TResponseData>(_url as string, _params as TParams)
          .then(handleApiResponse)
  });

  return ({
    countErrorCertification: data?.errorCertification ?? 0,
    isLoadingVerificationsCount: isFetching,
    countFemale: data?.female ?? 0,
    countOthers: data?.others ?? 0,
    countWhite: data?.white ?? 0,
    countMale: data?.male ?? 0,
    countScam: data?.scam ?? 0,
    refetch,
    error
  });

};
